import React from "react";

class ApptBook extends React.Component {
    
    render () {
        const { classes } = this.props;

        return (
        <div className={classes.root}>
            
        </div>
        )
    }
}

export default ApptBook; 